<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container">
	<h1 class="mb-4 text-center">Comment installer Legend-Binder ?</h1>

	<div class="dowloads-container main-container">
		<a (click)="scrollTo('ios')" class="m-4 btn btn-primary btn-gradient btn-xl" title="donwloads IOS app">
			<i class="fa-brands fa-apple pr-2"></i>iPhone<br/>
		</a>
		<a (click)="scrollTo('android')" class="m-4 btn btn-primary btn-gradient btn-xl" title="donwloads Android app">
			<i class="fa-brands fa-google-play pr-2"></i>Android
		</a>
	</div>

	<!-- ios -->
	<article id="ios">
		<header class="header p-4 mb-4">
			<i class="fa-brands fa-apple pr-2 text-4xl"></i>
			<div class="badge badge-primary">SUR IPHONE (iOS)</div>
		</header>

		<section class="steps-container">
			<!-- step 1 -->
			<div class="step">
				<div class="step-title">
					<div class="binder-number-container mr-4">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">1</span>
					</div>
					<div class="step-texte">
						Appuyer sur le bouton de partage.
					</div>
				</div>
				<img src="img/skin/install/ios-step-2.jpg" class="step-img" alt="Bouton partage"/>
			</div>

			<!-- step 2 -->
			<div class="step">
				<div class="step-title">
					<div class="binder-number-container mr-4">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">2</span>
					</div>
					<div class="step-texte">
						Sélectionner "Sur l'écran d'accueil".
					</div>
				</div>
				<img src="img/skin/install/ios-step-3.jpg" class="step-img" alt="Ecran d'accueil"/>
			</div>

			<!-- step 3 -->
			<div class="step">
				<div class="step-title">
					<div class="binder-number-container mr-4">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">3</span>
					</div>
					<div class="step-texte">
						L'application est ajoutée sur votre écran d'accueil.
					</div>
				</div>
				<img src="img/skin/install/ios-step-4.jpg" class="step-img" alt="Installation terminée"/>
			</div>
		</section>
		<footer>
			<div class="footer-step">
				<div class="app-icon">
					<img src="img/logo/logo-trasnparent.png" alt="App icon"/>
				</div>
				<div>
					Une fois ajouté, l'icône <span class="text-primary">Legend-Binder</span> apparaîtra sur votre écran d'accueil, comme une application classique.
				</div>
			</div>
			<div class="footer-step">
				<i class="fa-regular fa-lightbulb-exclamation-on text-4xl text-primary mr-4 icon-idea"></i>
				<div>
					<span class="text-primary">Bon à savoir :</span><br/>
					En ajoutant Legend Binder à votre écran d'accueil, vous profitez d'un accès rapide et d'une expérience optimsée, comme une application native.
				</div>
			</div>
		</footer>
	</article>

	<!-- android -->
	<article id="android">
		<header class="header p-4 mb-4">
			<i class="fa-brands fa-google-play pr-2 text-4xl text-success"></i>
			<div class="badge badge-success">SUR ANDROID</div>
		</header>

		<section class="steps-container">
			<!-- step 1 -->
			<div class="step">
				<div class="step-title">
					<div class="binder-number-container mr-4">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">1</span>
					</div>
					<div class="step-texte">
						Appuyer sur "Installer" si le bouton apparaît ou sur les trois points en haut à droite.
					</div>
				</div>
				<img src="img/skin/install/android-step-4.jpg" class="step-img" alt="Bouton partage"/>
			</div>

			<!-- step 2 -->
			<div class="step">
				<div class="step-title">
					<div class="binder-number-container mr-4">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">2</span>
					</div>
					<div class="step-texte">
						Choisir "Ajouter à l'écran d'accueil" ou "Installer l'application".
					</div>
				</div>
				<img src="img/skin/install/android-step-3.jpg" class="step-img" alt="Ecran d'accueil"/>
			</div>

			<!-- step 3 -->
			<div class="step">
				<div class="step-title">
					<div class="binder-number-container mr-4">
						<img src="img/skin/number-violet.png" alt="logo-number"/>
						<span class="number text-3xl text-primary">3</span>
					</div>
					<div class="step-texte">
						Valider.
					</div>
				</div>
				<img src="img/skin/install/android-step-2.jpg" class="step-img" alt="Installation terminée"/>
			</div>
		</section>
		<footer>
			<div class="footer-step">
				<div class="app-icon">
					<img src="img/logo/logo-trasnparent.png" alt="App icon"/>
				</div>
				<div>
					Une fois ajouté, l'icône <span class="text-primary">Legend-Binder</span> apparaîtra sur votre écran d'accueil, comme une application classique.
				</div>
			</div>
			<div class="footer-step">
				<i class="fa-regular fa-lightbulb-exclamation-on text-4xl text-primary mr-4 icon-idea"></i>
				<div>
					<span class="text-primary">Bon à savoir :</span><br/>
					En ajoutant Legend Binder à votre écran d'accueil, vous profitez d'un accès rapide et d'une expérience optimsée, comme une application native.
				</div>
			</div>
		</footer>
	</article>
</div>
